module.exports = __webpack_public_path__ + "img/info.bcd28dc1.svg";